import { BoardMember } from './boardmember.class';
import { ChatMessageType, IChatMessage } from './chatChannel';

export type ConversationGroupType = {
  _id?: string;
  name?: string;
  topic?: string;
  channelId: string;
  memberData: {
    userId: string;
    historySpanDate: Date;
    conversationLeader: boolean;
    inMeeting?: boolean;
  }[];
  isContactGroup: boolean;
};

export type LatestMessage = {
  message: string;
  decodedMessageHTML?: string;
  type: ChatMessageType;
  receivedAt: number;
  read: string[];
  readByThisUser?: boolean;
  fromUserId: string;
  senderFirstName: string;
  senderLastName: string;
  senderLogo: string;
  channelId: string;
};

export type ConversationGroupWithMembers = ConversationGroupType & {
  members?: BoardMember[];
  latestMessage: LatestMessage | null;
  unreadMessages: number;
  membersInVideoCall: number;
  membersDataObj?: {
    [userId: string]: {
      userId: string;
      historySpanDate: Date;
      conversationLeader: boolean;
    };
  };
};
export type SearchedMessage = IChatMessage & {
  conversation: ConversationGroupWithMembers;
  senderFirstName: string;
  senderLastName: string;
  senderLogo: string;
};
export type ContactGroupType = {
  _id?: string;
  name: string;
  description: string;
  memberIds: string[];
  position: number;
  deleted: boolean;
};
export type ContactGroupTypeFrontend = ContactGroupType & {
  members: BoardMember[];
  names?: string;
};

export function getNameOfConversation(
  conversation: ConversationGroupWithMembers,
  excludeUserId?: string
): string {
  if (conversation.name) return conversation.name;
  else {
    return getNameOfUsers(conversation.members, excludeUserId);
  }
}
export function getNameOfUsers(users: BoardMember[], excludeUserId?: string): string {
  let usersTemp = users;

  if (excludeUserId && usersTemp.length > 1) {
    usersTemp = usersTemp.filter((user) => user._id.toString() != excludeUserId);
  }

  let usersName: string = usersTemp.map((user) => user.firstName + ' ' + user.lastName).join(', ');
  if (usersName.length > 75) {
    usersName = usersName.substring(0, 75) + '...';
  }
  return usersName;
}
